import React, { useState, useEffect } from "react";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";
import Sidebar from "./AdminComp/Sidebar";
import BreadCrumb from "./AdminComp/BreadCrumb";
import { Edit, Trash2, Eye, Plus } from "react-feather";
import AddAgent from "./AdminComp/AddAgent";
import axios from "axios";
import { baseurl } from "../../component/Baseurl";

function UserAgent() {
  const [agents, setAgents] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(5);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(true);  // New state to manage loading

  // Fetch agents from API on component mount
  useEffect(() => {
    const getAgents = async () => {
      try {
        const response = await axios.get(`${baseurl}getAgents`);
        if (response.data.message === "Agents fetched successfully") {
          setAgents(response.data.agents);
        } else {
          setAgents([]); // Set agents to an empty array if no agents are returned
        }
      } catch (error) {
        console.error("Error fetching agents:", error.message);
        setAgents([]); // Set agents to an empty array in case of error
      } finally {
        setLoading(false); // Stop the loading spinner once the request is complete
      }
    };
    getAgents();
  }, []);

  const filteredAgents = agents.filter(
    (agent) =>
      agent.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      agent.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalRecords = filteredAgents.length;
  const totalPages = Math.ceil(totalRecords / recordsPerPage);
  const startIndex = (currentPage - 1) * recordsPerPage;
  const paginatedAgents = filteredAgents.slice(
    startIndex,
    startIndex + recordsPerPage
  );

  const handleView = (user) => {
    setSelectedUser(user);
    const modal = new window.bootstrap.Modal(document.getElementById("userDetailModal"));
    modal.show();
  };

  const handlePageChange = (page) => setCurrentPage(page);

  const handleRecordsPerPageChange = (e) => {
    setRecordsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page
  };

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />

        {/* Content area */}
        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <div>
            <BreadCrumb />
            <div className="container-fluid">
              <div className="crdmain mb-2">
                <div className="d-flex justify-content-between align-items-center" style={{ width: "100%" }}>
                  <h2 className="chart-title mb-0">Users/ Agents/ Distributors</h2>
                  <div className="ms-auto">
                    <AddAgent />
                  </div>
                </div>

                {/* Search and Records Per Page */}
                <div className="row g-1 mt-0 mb-0 justify-content-end">
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="input1"
                      placeholder="Search by name or email"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                  <div className="col-md-1 text-end">
                    <select
                      className="input1"
                      value={recordsPerPage}
                      onChange={handleRecordsPerPageChange}
                    >
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="15">15</option>
                    </select>
                  </div>
                </div>

                {/* Table */}
                <div className="row g-2 mt-0 mb-0">
                  <div className="col-md-12 p-0">
                    <div className="table-responsive classic-table">
                      <table className="table table-striped table-hover">
                        <thead className="table-header text-start">
                          <tr className="text-start">
                            <th className="text-start">#</th>
                            <th className="text-start">Name</th>
                            <th className="text-start">Email</th>
                            <th className="text-start">Unique ID</th>
                            <th className="text-start">City/State</th>
                            <th className="text-start">User From Date</th>
                            <th className="text-start">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan="7" className="text-center">
                                <div className="spinner-border text-primary" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </div>
                              </td>
                            </tr>
                          ) : (
                            paginatedAgents.length > 0 ? (
                              paginatedAgents.map((agent, index) => (
                                <tr key={agent.id}>
                                  <td>{startIndex + index + 1}</td>
                                  <td>{agent.name}</td>
                                  <td>{agent.email}</td>
                                  <td>{agent.agent_unique_id}</td>
                                  <td>{`${agent.city}, ${agent.state}`}</td>
                                  <td>{agent.userFromDate || "N/A"}</td>
                                  <td>
                                    <span className="btn2 me-2" title="Edit">
                                      <Edit size={15} />
                                    </span>
                                    <span
                                      className="btn2 me-2"
                                      title="View"
                                      onClick={() => handleView(agent)}
                                    >
                                      <Eye size={15} />
                                    </span>
                                    <span className="btn2" title="Delete">
                                      <Trash2 size={15} />
                                    </span>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="7" className="text-center">
                                  No records found.
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* Pagination */}
                <div className="d-flex justify-content-end mt-3">
                  <nav>
                    <ul className="pagination">
                      {[...Array(totalPages)].map((_, index) => (
                        <li
                          className={`page-item ${
                            currentPage === index + 1 ? "active" : ""
                          }`}
                          key={index}
                        >
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bootstrap Modal */}
      <div
        className="modal fade"
        id="userDetailModal"
        tabIndex="-1"
        aria-labelledby="userDetailModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="userDetailModalLabel">
                User Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
  {selectedUser ? (
    <table className="table table-bordered">
      <tbody>
        {Object.entries(selectedUser).map(([key, value]) => (
          <tr key={key}>
            <td>
              <strong>{key.replace(/([A-Z])/g, " $1").toUpperCase()}:</strong>
            </td>
            <td>{value || "N/A"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <div>Loading...</div>
  )}
</div>


            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserAgent;
